"use strict";
var zip_1 = require('../operator/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/rxjs/observable/zip.js
// module id = ../../../../rxjs/observable/zip.js
// module chunks = 4